export function  parseVersionName (version){
  version = parseInt(version)
  let versionName = '';
  if (version > 65535) {
      versionName = (version >> 16 & 0xff) + '.' + (version >> 8 & 0xff) + '.' + (version & 0xff)

  } else if(version === 0){
      return '-'
  }else{
      versionName = (version >> 8 & 0xff) + '.' + (version >> 4 & 0x0f) + '.' + (version & 0x0f)
  }

  return 'V' + versionName;
}
